<div  *ngIf="(branchAfarmOverview)">

  <div id="wrapnumber">
    <div  id="one" *ngIf="1" >

      <app-branch-gauge-setting-measurement description="Temperature"
                                            [mVariable]= "branchAfarmOverview.temperature_measurement"
                                            [sVariable]= "branchAfarmOverview.temperature_setpoint"
                                            [minAlarm] = "branchAfarmOverview.temperature_minimum"
                                            [maxAlarm] = "branchAfarmOverview.temperature_maximum"
                                            [scale]="{ min: 0, max: 30.0 }"
                                            >
      </app-branch-gauge-setting-measurement>
    </div>

    <div  id="two" *ngIf="1">

      <app-branch-gauge-setting-measurement description="Humidity"
                                            [mVariable]="branchAfarmOverview.rv_abs_outside"
                                            [sVariable]="branchAfarmOverview.rv_abs_product"
                                            [scale]="{ min: 0, max: 20.0 }"
              >
      </app-branch-gauge-setting-measurement>

    </div>

    <div  id="three" *ngIf="1">
      <app-branch-gauge-measurement description="Channel"
                                    [mVariable]="branchAfarmOverview.channel_temperature"
                                    [scale]="{ min: 0, max: 20.0 }">

      </app-branch-gauge-measurement>
    </div>

    <div  id="four" *ngIf="1">
      <app-branch-gauge-measurement description="Hatch"
                                    [mVariable]="branchAfarmOverview.hatch_position"
                                    [scale]="{ min: 0, max: 100.0 }">

      </app-branch-gauge-measurement>
    </div>
      <div  id="five" *ngIf="1">
        <app-branch-gauge-measurement description="CO2"
                                    [mVariable]="branchAfarmOverview.co2_measurement"
                                    [scale]="{ min: 0, max: 5000.0 }">

      </app-branch-gauge-measurement>
    </div>

    <div  id="six" >
      Hatch open today: {{ GetValueAsHours(hours_hatchopen_today) }} <br/>

      treatment_status:    {{  GetValue(treatment_status) }}  <br/>
      department_status:    {{ GetValue(department_status) }}  <br/>


    </div>


  <div  id="seven" >

    <div *ngIf="branchAfarmOverview.fanstatus_0">
      <app-branch-fan [mVariable]="branchAfarmOverview.fanstatus_0"></app-branch-fan>
    </div>
    <div *ngIf="branchAfarmOverview.fanstatus_1">
      <app-branch-fan [mVariable]="branchAfarmOverview.fanstatus_1"></app-branch-fan>
    </div>
    <div *ngIf="branchAfarmOverview.fanstatus_2">
      <app-branch-fan [mVariable]="branchAfarmOverview.fanstatus_2"></app-branch-fan>
    </div>
    <div *ngIf="branchAfarmOverview.fanstatus_3">
      <app-branch-fan [mVariable]="branchAfarmOverview.fanstatus_3"></app-branch-fan>
    </div>
  </div>




  </div>
</div>
